import { useState } from 'react';
import { Search } from '@nazka/nazka.mapframe.components';

import './map-search.css';

const options = [];

function MapSearch() {
  const [value, setValue] = useState();

  return (
    <div className="map-search">
      <Search
        clear
        className="map-search__search"
        onSelect={item => setValue(item)}
        options={options}
        placeholder="Zoek..."
        noResultsText="Geen resultaten..."
        value={value}
        width="340px"
      />
    </div>
  );
}

export default MapSearch;
